module.exports = __webpack_public_path__ + "static/media/icon-call-history.2f5ff5d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-call-history.svg
// module id = 1863
// module chunks = 0